/* PSI header — revamp 24 Oct 2026: desktop mega menus, phone menu drawer, header search overlay.
   Each part is wrapped on its own so a problem in one never stops the others (or the rest of the page). */
(function () {
  'use strict';
  var html = document.documentElement;
  function lock(on) { html.classList.toggle('psi-lock', !!on); }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- A. Desktop menus ---------- */
  try {
    var nav = $('[data-psi-nav]');
    if (nav) {
      var items = $$('[data-psi-drop]', nav), openItem = null, tOpen = null, tClose = null;
      var warm = function () { $$('.psi-mega img[loading="lazy"]', nav).forEach(function (i) { i.loading = 'eager'; }); nav.removeEventListener('pointerenter', warm); };
      nav.addEventListener('pointerenter', warm); nav.addEventListener('focusin', warm);
      var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
      var show = function (li) {
        if (openItem && openItem !== li) hide(openItem);
        var p = li.querySelector('.psi-mega, .psi-drop'); if (!p) return;
        p.hidden = false; li.classList.add('is-open'); li.querySelector('.psi-nav__top').setAttribute('aria-expanded', 'true'); openItem = li; li._psiAt = Date.now();
        html.classList.add('psi-mega-open');
      };
      var hide = function (li) {
        var p = li.querySelector('.psi-mega, .psi-drop'); if (p) p.hidden = true;
        li.classList.remove('is-open'); li.querySelector('.psi-nav__top').setAttribute('aria-expanded', 'false');
        if (openItem === li) { openItem = null; html.classList.remove('psi-mega-open'); }
      };
      items.forEach(function (li) {
        var btn = li.querySelector('.psi-nav__top');
        btn.addEventListener('click', function (e) { e.preventDefault();
          if (li.classList.contains('is-open')) { if (fine && Date.now() - (li._psiAt || 0) < 700) return; hide(li); } else show(li); });
        if (fine) {
          li.addEventListener('mouseenter', function () { clearTimeout(tClose); clearTimeout(tOpen); tOpen = setTimeout(function () { show(li); }, openItem ? 0 : 110); });
          li.addEventListener('mouseleave', function () { clearTimeout(tOpen); tClose = setTimeout(function () { hide(li); }, 220); });
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openItem) { var b = openItem.querySelector('.psi-nav__top'); hide(openItem); b && b.focus(); } });
      document.addEventListener('click', function (e) { if (openItem && !openItem.contains(e.target)) hide(openItem); });
      nav.addEventListener('focusout', function (e) { if (openItem && e.relatedTarget && !openItem.contains(e.relatedTarget)) hide(openItem); });
      // theme tabs
      $$('.psi-mega__inner--themes').forEach(function (box) {
        var tabs = $$('[data-psi-tab]', box), panes = $$('[data-psi-pane]', box);
        var pick = function (k) {
          tabs.forEach(function (t) { var on = t.getAttribute('data-psi-tab') === k; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', String(on)); });
          panes.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-psi-pane') === k); });
        };
        tabs.forEach(function (t) {
          t.addEventListener('click', function () { pick(t.getAttribute('data-psi-tab')); if (t.getAttribute('data-psi-tab') === 'az') { var f = $('[data-psi-az-filter]', box); f && f.focus(); } });
          if (fine) t.addEventListener('mouseenter', function () { pick(t.getAttribute('data-psi-tab')); });
        });
        var f = $('[data-psi-az-filter]', box), list = $('[data-psi-az]', box);
        if (f && list) f.addEventListener('input', function () {
          var q = f.value.toLowerCase().replace(/[^a-z0-9]/g, '');
          $$('a', list).forEach(function (a) { a.parentNode.hidden = !!q && a.getAttribute('data-n').replace(/[^a-z0-9]/g, '').indexOf(q) === -1; });
        });
      });
    }
  } catch (e) { if (window.console) console.warn('[psi-header nav]', e && e.message); }

  /* keep Tab inside an open overlay (menu drawer / search) */
  function trap(d, e) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),input:not([type=hidden]),summary', d).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return; var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }

  /* ---------- B. Phone menu drawer ---------- */
  var mnav = $('#psi-mnav');
  function closeMnav(noFocus) {
    if (!mnav || mnav.hidden) return;
    mnav.classList.remove('is-open'); lock(false);
    $$('[data-psi-mnav-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!mnav.classList.contains('is-open')) mnav.hidden = true; }, 260);
    if (!noFocus) { var ob = $('[data-psi-mnav-open]'); if (ob && ob.offsetParent !== null) try { ob.focus({ preventScroll: true }); } catch (e) {} }
  }
  try {
    if (mnav) {
      if (mnav.parentNode !== document.body) document.body.appendChild(mnav);   // escape header stacking contexts
      $$('[data-psi-mnav-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          mnav.hidden = false; lock(true); b.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(function () { mnav.classList.add('is-open'); var x = $('.psi-mnav__x', mnav); x && x.focus({ preventScroll: true }); });
        });
      });
      $$('[data-psi-mnav-close]', mnav).forEach(function (b) { b.addEventListener('click', function () { closeMnav(); }); });
      mnav.addEventListener('keydown', function (e) { trap(mnav, e); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMnav(); });
      var mt = $$('[data-psi-mtab]', mnav), mp = $$('[data-psi-mpane]', mnav);
      mt.forEach(function (t) {
        t.addEventListener('click', function () {
          var k = t.getAttribute('data-psi-mtab');
          mt.forEach(function (x) { var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', String(on)); });
          mp.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-psi-mpane') === k); });
        });
      });
      var mf = $('[data-psi-maz-filter]', mnav), ml = $('[data-psi-maz]', mnav);
      if (mf && ml) mf.addEventListener('input', function () {
        var q = mf.value.toLowerCase().replace(/[^a-z0-9]/g, '');
        $$('a', ml).forEach(function (a) { a.parentNode.hidden = !!q && a.getAttribute('data-n').replace(/[^a-z0-9]/g, '').indexOf(q) === -1; });
      });
    }
  } catch (e) { if (window.console) console.warn('[psi-header menu]', e && e.message); }

  /* ---------- C. Search overlay ---------- */
  try {
    var box = $('#psi-search');
    if (!box) return;
    if (box.parentNode !== document.body) document.body.appendChild(box);
    var input = $('#psi-search-q', box), res = $('#psi-search-res', box), clr = $('.psi-search__clear', box), form = $('form', box);
    var themes = null, cats = null, popular = [], tiles = [], ctl = null, cache = {}, timer = null, act = -1, lastQ = '';
    var SYN = { dino: 'dinosaur', dinosar: 'dinosaur', dinasour: 'dinosaur', elsa: 'frozen', anna: 'frozen', spider: 'spidey', spiderman: 'spidey', mcqueen: 'car', cars: 'car',
      bheem: 'bheem', kanna: 'krishna', mickey: 'mickey', minnie: 'minnie', peppa: 'peppa', paw: 'paw', cocomelon: 'coco', marvel: 'avengers', hulk: 'avengers', ironman: 'avengers',
      superhero: 'avengers', fairy: 'tinkerbell', rocket: 'space', astronaut: 'space', safari: 'jungle', animal: 'jungle', lion: 'jungle', sea: 'mermaid', ocean: 'mermaid',
      cow: 'farm', soccer: 'football', ipl: 'cricket', rainbow: 'unicorn', plane: 'aeroplane', airplane: 'aeroplane', kitty: 'hello kitty', mario: 'super mario', shinchan: 'shinchan' };
    var CSYN = { topper: 'topper', toppers: 'topper', backdrop: 'backdrop', backdrops: 'backdrop', banner: 'backdrop', flex: 'backdrop', round: 'round', circle: 'round', arch: 'arch',
      square: 'square', welcome: 'welcome', board: 'welcome', cutout: 'cutout', cutouts: 'cutout', standee: 'cutout', gift: 'gift', gifts: 'gift', return: 'gift', bag: 'bag', bags: 'bag',
      kit: 'kit', kits: 'kit', combo: 'kit', invite: 'invite', invitation: 'invite', card: 'invite', video: 'video', hat: 'hat', cap: 'hat', balloon: 'balloon', balloons: 'balloon',
      swirl: 'swril', swirls: 'swril', hanging: 'hanging', bunting: 'hanging', poster: 'poster', chalk: 'chalk', photobooth: 'photobooth', booth: 'photobooth', mask: 'mask', badge: 'badge',
      sticker: 'sticker', cake: 'cake', table: 'table', cover: 'cover', chocolate: 'chocolate', box: 'box', boxes: 'box', props: 'props', glasses: 'glasses', fan: 'fan', banner12: 'months' };
    function norm(s) { return String(s).toLowerCase().replace(/theme/g, '').replace(/[^a-z0-9]+/g, ''); }
    function lev(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      var pp = null, p = [], i, j; for (j = 0; j <= b.length; j++) p[j] = j;
      for (i = 1; i <= a.length; i++) { var c = [i], m = i;
        for (j = 1; j <= b.length; j++) {
          c[j] = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
          if (pp && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) c[j] = Math.min(c[j], pp[j - 2] + 1);   // swapped letters (jungel -> jungle) count as one typo
          if (c[j] < m) m = c[j]; }
        if (m > max) return max + 1; pp = p; p = c; }
      return p[b.length];
    }
    function sc(key, words, q) {
      if (!q) return 0;
      if (key.indexOf(q) === 0) return 100;
      if (words.some(function (w) { return w.indexOf(q) === 0; })) return 85;
      if (q.length >= 4 && key.indexOf(q) !== -1) return 60;
      if (q.length >= 4) {
        var max = q.length >= 7 ? 2 : 1, best = max + 1;
        words.forEach(function (w) { var d = lev(q, w.slice(0, q.length + 1), max); if (d < best) best = d; d = lev(q, w.slice(0, q.length), max); if (d < best) best = d; });
        if (best <= max) return 45 - best * 10;
      }
      return 0;
    }
    function build() {
      if (themes) return;
      themes = []; cats = []; var seen = {};
      $$('[data-psi-t]').forEach(function (a) {
        var n = a.getAttribute('data-psi-t'); if (seen[a.href]) return; seen[a.href] = 1;
        themes.push({ name: n, href: a.getAttribute('href'), img: a.getAttribute('data-img') || '', key: norm(n), words: n.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean) });
      });
      $$('[data-psi-c]').forEach(function (a) {
        if (seen[a.href]) return; seen[a.href] = 1;
        var n = (a.textContent || '').replace(/\s+/g, ' ').trim(); var im = a.querySelector('img');
        cats.push({ name: n, href: a.getAttribute('href'), img: a.getAttribute('data-img') || (im ? im.getAttribute('src') : ''), key: norm(n), words: n.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean) });
      });
      popular = $$('#psi-mnav [data-psi-mpane="pop"] .psi-tcard').slice(0, 8).map(function (a) { return { name: a.textContent.trim(), href: a.getAttribute('href') }; });
      tiles = $$('#psi-mnav .psi-ptile').map(function (a) { return { name: a.textContent.trim(), href: a.getAttribute('href') }; });
    }
    function recent(add) {
      var r = []; try { r = JSON.parse(localStorage.getItem('psi_recent') || '[]') || []; } catch (e) { r = []; }
      if (add) { add = add.trim(); if (add.length < 2) return r; r = [add].concat(r.filter(function (x) { return x.toLowerCase() !== add.toLowerCase(); })).slice(0, 5); try { localStorage.setItem('psi_recent', JSON.stringify(r)); } catch (e) {} }
      return r;
    }
    function tokens(v) { return v.toLowerCase().split(/[^a-z0-9]+/).filter(function (t) { return t.length >= 2; }); }
    function matchThemes(v) {
      var full = norm(v), tk = tokens(v), out = [];
      themes.forEach(function (t) {
        var s = sc(t.key, t.words, full) * 1.1;
        tk.forEach(function (q) { var syn = SYN[q]; s = Math.max(s, sc(t.key, t.words, q)); if (syn) s = Math.max(s, sc(t.key, t.words, norm(syn)) - 5); });
        if (SYN[full]) s = Math.max(s, sc(t.key, t.words, norm(SYN[full])));
        if (s > 0) out.push({ t: t, s: s });
      });
      return out.sort(function (a, b) { return b.s - a.s; });
    }
    function matchCats(v) {
      var tk = tokens(v), out = [];
      cats.forEach(function (c) {
        var s = 0;
        tk.forEach(function (q) { var k = CSYN[q] || q; if (q.length < 3) return; s = Math.max(s, sc(c.key, c.words, k)); });
        if (s >= 60) out.push({ c: c, s: s });
      });
      return out.sort(function (a, b) { return b.s - a.s || a.c.name.length - b.c.name.length; });
    }
    function rs(n) { var x = parseFloat(n); return isNaN(x) ? '' : 'Rs. ' + (Math.round(x) === x ? x.toFixed(0) : x.toFixed(2)); }
    function opt(href, img, title, sub, cls) {
      return '<a class="psi-sr__opt ' + (cls || '') + '" role="option" href="' + esc(href) + '">' +
        '<span class="psi-sr__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</span>' +
        '<span class="psi-sr__t">' + title + (sub ? '<small>' + sub + '</small>' : '') + '</span><span class="psi-sr__go" aria-hidden="true">›</span></a>';
    }
    function empty() {
      var r = recent(), h = '';
      if (r.length) h += '<p class="psi-sr__h">Recent searches</p><div class="psi-sr__chips">' + r.map(function (x) { return '<button type="button" class="psi-chip" data-q="' + esc(x) + '">🕘 ' + esc(x) + '</button>'; }).join('') + '</div>';
      h += '<p class="psi-sr__h">Popular themes</p><div class="psi-sr__chips">' + popular.map(function (x) { return '<a class="psi-chip" href="' + esc(x.href) + '">' + esc(x.name) + '</a>'; }).join('') + '</div>';
      h += '<p class="psi-sr__h">Shop by product</p><div class="psi-sr__chips">' + tiles.map(function (x) { return '<a class="psi-chip psi-chip--soft" href="' + esc(x.href) + '">' + esc(x.name) + '</a>'; }).join('') + '</div>';
      h += '<p class="psi-sr__tip">Tip: combine them — “jungle cake topper”, “unicorn backdrop”.</p>';
      res.innerHTML = h; act = -1; input.setAttribute('aria-expanded', 'false');
    }
    function render(v, products, loading) {
      var th = matchThemes(v).slice(0, 5), ct = matchCats(v).slice(0, 4), h = '';
      if (th.length && ct.length && th[0].s >= 80) {
        var q2 = th[0].t.name + ' ' + ct[0].c.name.replace(/s$/, '');
        h += '<p class="psi-sr__h">Best match</p>' + opt('/search?q=' + encodeURIComponent(q2) + '&type=product&options%5Bprefix%5D=last', th[0].t.img, esc(th[0].t.name) + ' · ' + esc(ct[0].c.name), 'All matching products', 'psi-sr__opt--best');
      }
      if (th.length) h += '<p class="psi-sr__h">Themes</p>' + th.map(function (x) { return opt(x.t.href, x.t.img, esc(x.t.name) + ' theme', 'Backdrops, cutouts, toppers & more'); }).join('');
      if (ct.length) h += '<p class="psi-sr__h">Product types</p>' + ct.map(function (x) { return opt(x.c.href, x.c.img, esc(x.c.name), 'All themes'); }).join('');
      h += '<p class="psi-sr__h">Products</p>';
      if (products && products.length) h += products.map(function (p) {
        var im = p.image || (p.featured_image && p.featured_image.url) || '';
        if (im) im = im + (im.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        return opt(p.url, im, esc(p.title), rs(p.price));
      }).join('');
      else if (loading) h += '<p class="psi-sr__load">Searching…</p>';
      else h += '<p class="psi-sr__none">No products found for “' + esc(v) + '”. <a href="https://wa.me/919841131131?text=' + encodeURIComponent('Hi Party Supplies India! I am looking for: ' + v) + '" target="_blank" rel="noopener">Ask us on WhatsApp</a> — we can make it custom.</p>';
      h += '<a class="psi-sr__all" href="/search?q=' + encodeURIComponent(v) + '&options%5Bprefix%5D=last">See all results for “' + esc(v) + '” →</a>';
      res.innerHTML = h; act = -1; input.setAttribute('aria-expanded', 'true');
    }
    function fetchP(v) {
      var key = v.toLowerCase();
      if (cache[key]) { render(v, cache[key]); return; }
      render(v, null, true);
      if (ctl && ctl.abort) ctl.abort();
      ctl = window.AbortController ? new AbortController() : null;
      fetch('/search/suggest.json?q=' + encodeURIComponent(v) + '&resources%5Btype%5D=product&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last', ctl ? { signal: ctl.signal } : {})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { var p = (d && d.resources && d.resources.results && d.resources.results.products) || []; cache[key] = p; if (input.value.trim().toLowerCase() === key) render(v, p); })
        .catch(function (e) { if (e && e.name === 'AbortError') return; if (input.value.trim().toLowerCase() === key) render(v, []); });
    }
    function onInput() {
      var v = input.value.trim(); clr.hidden = !v;
      clearTimeout(timer);
      if (!v) { empty(); return; }
      render(v, cache[v.toLowerCase()] || null, !cache[v.toLowerCase()]);
      if (v.length >= 2) timer = setTimeout(function () { fetchP(v); }, 170);
    }
    var lastFocus = null;
    function open(e) {
      if (e) e.preventDefault();
      var fromMenu = mnav && mnav.contains(document.activeElement);
      closeMnav(true);
      build(); lastFocus = fromMenu ? $('[data-psi-mnav-open]') : document.activeElement;
      box.hidden = false; lock(true);
      input.focus();
      requestAnimationFrame(function () { box.classList.add('is-open'); });
      if (!input.value) empty(); else onInput();
    }
    function close() {
      if (box.hidden) return;
      box.classList.remove('is-open'); lock(false);
      setTimeout(function () { if (!box.classList.contains('is-open')) box.hidden = true; }, 200);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    $$('[data-psi-search-open]').forEach(function (b) { b.addEventListener('click', open); b.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Spacebar') open(e); }); });
    box.addEventListener('keydown', function (e) { trap(box, e); });
    /* iOS back/forward cache: never come back with an overlay stuck open */
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) { close(); closeMnav(true); lock(false); } });
    $$('[data-psi-search-close]', box).forEach(function (b) { b.addEventListener('click', close); });
    input.addEventListener('input', onInput);
    clr.addEventListener('click', function () { input.value = ''; onInput(); input.focus(); });
    res.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('button[data-q]');
      if (c) { input.value = c.getAttribute('data-q'); onInput(); input.focus(); return; }
      var a = e.target.closest && e.target.closest('a'); if (a && input.value.trim()) recent(input.value);
    });
    input.addEventListener('keydown', function (e) {
      var opts = $$('.psi-sr__opt, .psi-sr__all', res);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (!opts.length) return;
        act = (act + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach(function (o, k) { o.classList.toggle('is-act', k === act); }); opts[act].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter') {
        var v = input.value.trim(); if (!v) { e.preventDefault(); return; }
        recent(v);
        if (act >= 0 && opts[act]) { e.preventDefault(); window.location.href = opts[act].href; return; }
        var th = matchThemes(v), ct = matchCats(v);
        if (th.length && th[0].s >= 100 && !ct.length) { e.preventDefault(); window.location.href = th[0].t.href; }
      }
    });
    form.addEventListener('submit', function () { recent(input.value); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      var t = e.target, typing = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable);
      if (!typing && e.key === '/' && box.hidden) { open(e); }
    });
  } catch (e) { if (window.console) console.warn('[psi-header search]', e && e.message); }
})();

/* ---------- D. Account menu ---------- */
(function () {
  'use strict';
  try {
    var box = document.querySelector('[data-psi-acct]'); if (!box) return;
    var btn = box.querySelector('[data-psi-acct-btn]'), menu = box.querySelector('.psi-acct__menu');
    var set = function (o) { menu.hidden = !o; btn.setAttribute('aria-expanded', String(o)); };
    btn.addEventListener('click', function (e) { e.preventDefault(); set(menu.hidden); });
    document.addEventListener('click', function (e) { if (!menu.hidden && !box.contains(e.target)) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { set(false); btn.focus(); } });
  } catch (e) { if (window.console) console.warn('[psi-header account]', e && e.message); }
})();
